var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:_vm.buttonClasses,on:{"click":_vm.handleClick}},[_vm._v(" "+_vm._s(_vm.label)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }